import Trans from 'next-translate/Trans'
import { MYBOARD_UPDATE_ASSIGN } from 'tennders-stracture/libs/permissions'
import RequiresPermission from 'tennders-auth/components/RequiresPermission'
import GHref from 'tennders-market/common/components/element/GHref'
import { RowPropsTransaction } from 'tennders-market/bin/components/row/RowProps'
import useAssignTo from 'tennders-transactions/hooks/useAssignTo'
import IconAssignTracker from '../../../../../../icons/icon-assign-tracker.svg'

const RowAssignBrokerAction = ({ transaction, color }:RowPropsTransaction) => {
  const { setAssignTo } = useAssignTo()

  const fallBack = (
    <GHref className="bg-dark disabled d-flex col flex-center text-center" tip="You dont have permission">
      <IconAssignTracker />
      <div className="icon-label">
        <Trans i18nKey="common:broker" />
      </div>
    </GHref>
  )
  return (
    <div>
      <RequiresPermission
        fallbackComponent={fallBack}
        requiredPermissions={[
          MYBOARD_UPDATE_ASSIGN
        ]}
      >
        <GHref
          onClick={() => setAssignTo(transaction?.id)}
          className="bg-dark d-flex col flex-center text-center"
        >
          <IconAssignTracker />
          <div className="icon-label" style={{ color }}>
            <Trans i18nKey="common:broker" />
          </div>
        </GHref>
      </RequiresPermission>
    </div>
  )
}

export default RowAssignBrokerAction
